import { combineReducers } from 'redux';

import {
  CREATE_PARTIAL_USER_SUCCESS,
  REGISTER_USER_SUCCESS,
} from 'actionTypes';
import { byIdReducerTemplate, allIdsReducerTemplate } from '../reducerUtils';

export default combineReducers({
  byId: byIdReducerTemplate('users'),
  allIds: allIdsReducerTemplate([
    CREATE_PARTIAL_USER_SUCCESS,
    REGISTER_USER_SUCCESS,
  ]),
});



// WEBPACK FOOTER //
// ./src/reducers/entities/usersReducer.js